import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ManagePukalService } from '../../../../services/manage-pukal.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs';
import {AccountOffice } from '../../../../models/pukal-reports.model';

@Component({
    selector: 'dialog-ngr-editaccount',
    templateUrl: 'dialog.editaccount.html',
    styleUrls: ['dialog.editaccount.css']
})
export class EditAccountPukalStateGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    loading: boolean = true;
    isSubmit: boolean = false;
    editaccform: FormGroup;
    errorMessage: string = '';
    objects = [];
    creationDate: any;
    activationDate: any;
    lastModifiedDate: any;
    terminationDate: any;
    createdUserId: any;
    userId: any;
    screenCode: string = '';
    selectedaccoffCode: any;

    accOffices$: Observable<AccountOffice[]>;
    warrant_auth_code: string = 'NG';

    constructor(public dialogRef: MatDialogRef<EditAccountPukalStateGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public accData: any,
        private fb: FormBuilder,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.accOffices$ = this.managePukalService.getAccountOffices(this.warrant_auth_code);

        this.editaccform = new FormGroup({
            selectedagencyname: new FormControl({ value: '', disabled: true }),
            selectedagencyoffcode: new FormControl({ value: '', disabled: true }),
            ptjaddress: new FormControl({ value: '', disabled: false }, Validators.required),
            selectedaccoffCode: new FormControl({ value: '', disabled: false }, Validators.required),
            pukalnumber: new FormControl({ value: '', disabled: true }),
            warrantdepartment: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(4)]),
            warrantptj: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(8)]),
            vote: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3)]),
            chargedeparment: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(4)]),
            changeptj: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(8)]),
            vpa: new FormControl({ value: '', disabled: false }, Validators.maxLength(6)),
            vpss: new FormControl({ value: '', disabled: false }, Validators.maxLength(12)),
            cp: new FormControl({ value: '', disabled: false }, Validators.maxLength(1)),
            selectedobject: new FormControl({ value: '', disabled: false }, Validators.required),
            selectedactivation: new FormControl({ value: '', disabled: true }),
            setia: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(12)]),
            recordStatus: new FormControl({ value: '', disabled: true })
        });

        this.screenCode = this.accData.screenCode;
        let agencyCode = this.accData.selectedAcc.Airline_Agency_Code;
        let accoffCode = this.accData.selectedAcc.Acc_Off_Code;
        let accnumber = this.accData.selectedAcc.Acc_No;

        let init_sub = this.managePukalService.initEditNGRPukalAccountDetails(agencyCode, accoffCode, accnumber)
            .subscribe(
                (data) => {
                    this.loading = false;

                    this.editaccform.setValue({
                        selectedagencyname: data.Agency_Name,
                        selectedagencyoffcode: data.Airline_Agency_Code,
                        selectedaccoffCode: data.Acc_Off_Code,
                        ptjaddress: data.Acc,
                        pukalnumber: data.Acc_No,
                        warrantdepartment: data.Warrant_Dept,
                        warrantptj: data.Warrant_RCCC,
                        vote: data.Vote,
                        chargedeparment: data.Charge_Dept,
                        changeptj: data.Charge_RCCC,
                        vpa: data.Program,
                        vpss: data.Project,
                        cp: data.CP,
                        selectedobject: data.Object,
                        selectedactivation: data.Acc_Sts,
                        setia: data.Setia,
                        recordStatus: data.Rcd_Sts
                    });
                    this.objects = data.TransObjects;
                    this.creationDate = data.Creation_Date;
                    this.activationDate = data.Activation_Date;
                    this.lastModifiedDate = data.Sys_Date;
                    this.terminationDate = data.Termination_Date;
                    this.createdUserId = data.Created_User_Id;
                    this.userId = data.User_Id;
                },
                error => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the changes?");

        if (cfm) {
            this.isSubmit = true;

            let pukalAccount = {
                Acc: this.editaccform.get('ptjaddress')!.value,
                Warrant_Dept: this.editaccform.get('warrantdepartment')!.value,
                Warrant_RCCC: this.editaccform.get('warrantptj')!.value,
                Vote: this.editaccform.get('vote')!.value,
                Charge_Dept: this.editaccform.get('chargedeparment')!.value,
                Charge_RCCC: this.editaccform.get('changeptj')!.value,
                Program: this.editaccform.get('vpa')!.value,
                Project: this.editaccform.get('vpss')!.value,
                Setia: this.editaccform.get('setia')!.value,
                CP: this.editaccform.get('cp')!.value,
                Objects: this.editaccform.get('selectedobject')!.value,
                Airline_Agency_Code: this.editaccform.get('selectedagencyoffcode')!.value,
                Acc_Off_Code: this.editaccform.get('selectedaccoffCode')!.value,
                Acc_No: this.editaccform.get('pukalnumber')!.value
            }

            let save_sub = this.managePukalService.updateNGRPukalAccountDetails(pukalAccount)
                .subscribe(
                    (data) => {
                        this.dialogRef.close('Edit successful');
                    },
                    error => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}